import { render } from "./InsurancePartnerList.vue?vue&type=template&id=72459968&scoped=true"
import script from "./InsurancePartnerList.vue?vue&type=script&lang=js"
export * from "./InsurancePartnerList.vue?vue&type=script&lang=js"

import "./InsurancePartnerList.vue?vue&type=style&index=0&id=72459968&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72459968"]])

export default __exports__